import HBIcon from "@/components/HBIcon";
import HBConfirm from "@/components/HBModal/confirm";
import Image from "@/components/Image";
import { openUdesk } from "@/utils/initUdesk";
import styles from "./index.module.less";

/**
 * 大企业填写提醒
 * @see https://www.figma.com/design/yMHkRrGYZQ7YP2yQgbeqif/%E4%BC%81%E4%B8%9A%E7%89%88?node-id=3746-1676&t=z0VSMQj8KnRpVdoW-0
 * @description 需求文档 https://doc.huanleguang.com/pages/viewpage.action?pageId=438703105
 */
export function openBigCompanyAlert() {
  return HBConfirm.open({
    title: "提交失败",
    leftIcon: <HBIcon type="ic_clear" className={styles.clearIcon} />,
    hideIcon: true,
    closable: true,
    width: 480,
    content: (
      <div
        className={styles.content}
        data-dialog-title="素材商用授权弹窗"
        data-gd-expose="dialog_expose"
      >
        <div className={styles.desc}>
          <p>
            当前订单“<strong>素材下载会员</strong>
            ”授权范围适用于中小微企业，与您填写的授权主体信息存在差异，存在版权风险！
            <a
              data-button-name="详见版权说明"
              data-gd-click="button_click"
              href="https://huaban.com/about/disclaimer?activeKey=5"
              target="_blank"
            >
              {" 详见版权说明 >"}
            </a>
          </p>
        </div>
        <div className={styles.img}>
          <Image
            src="https://grocery-cdn.huaban.com/file/c135ed50232e11f0a59ecb9f4a74cfb9.png"
            alt="二维码"
            width={106}
            height={106}
          />
          <div>
            为保障您的版权合规, 请尽快联系专属客户服务经理解决! 或联系{" "}
            <span
              className="primary-text-btn"
              data-button-name="在线客服"
              data-gd-click="button_click"
              onClick={openUdesk}
            >
              在线客服
            </span>
          </div>
        </div>
      </div>
    ),
    okButtonProps: {
      "data-contetn-source": `素材商用授权弹窗`,
      "data-button-name": `我知道了`,
      "data-gd-click": "button_click",
    },
    okText: "我知道了",
    okType: "primary",
    hideCancelBtn: true,
  });
}
